// file modes (dir, file, link)

export default {
  DIR: 'DIR',
  FILE: 'FILE',
  SYMBOLIC_LINK: 'SYMBOLIC_LINK'
}
